import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import Vant from 'vant';
import 'vue-beauty/package/style/vue-beauty.min.css'
//import components
import vueBeauty from 'vue-beauty'
import 'vant/lib/index.css';
import '@/icons';
import {kefucommons} from '@/utils/kefu';
import Utils from "./common/weixin";

Vue.use(Vant);
Vue.use(vueBeauty);
Vue.use(VueCookies);
kefucommons.init();

const noauth_page=['/','/goods_detail','/login','/search','/register','/reset_password','/auth_binding','/auth','/position_search','/position_list','/position_detail',
'/group_booking','/auth_new','/getauthcode','/course_search'];
router.beforeEach((to, from, next) => {

	var pageauth=noauth_page.indexOf(to.path);
	console.log("to:",to);
	
	if(Utils.isIOS()&&!Utils.isReady()){
		console.log("initwxmain")
		if (from.path === '/') {
		      Utils.initWXConfig();
		}
	}

	if (to.meta.title) {
	  document.title = to.meta.title
	}

	if(pageauth==-1&&!VueCookies.isKey("user_token"))
	{
		
		VueCookies.set("beforeLoginUrl",to.fullPath);
		next({path:'/auth_new'});
	}
	else{
		next();
	}

  /* 路由发生变化修改页面title */

  //next();


  })

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
